import axios from 'axios';
import * as types from './types';
import { API_URL_PATHS } from '../../constants/url';
import { getTokenHeader } from '../../helpers/tokenHelper';
import { NOTIFICATION_STATUS } from '../../constants';
import { displayNotification } from './NotificationActions';
import { removeStoredUnsavedAnalysis, checkAllFormsValidity } from './CaseActions';
import { validateAnalysisValues } from '../../helpers/validateFormsDemo';

export const updateOSGBounds = (specimenId, bounds) => ({
  type: types.SET_OSG_BOUNDS,
  payload: {
    specimenId,
    bounds,
  },
});

const getServerErrorNotification = (error) => {
  let errorMessage;
  if (error.response) {
    errorMessage = error.response.data.message;
  } else {
    errorMessage = 'Server might not be availible';
  }
  return {
    status: NOTIFICATION_STATUS.error,
    message: errorMessage,
  };
};

const getSuccessNotification = message => ({
  status: NOTIFICATION_STATUS.success,
  message,
});

export const storeCurrentRotationAngleOfSpecimenImage = (degrees, specimenId) => ({
  type: types.STORE_ROTATION_ANGLE_OF_SPECIMEN_IMAGE,
  payload: {
    degrees,
    specimenId,
  },
});

export const updateTableHasChanged = boolean =>
  ({
    type: types.SPECIMEN_TABLE_HAS_CHANGED, payload: boolean,
  });

export const updateRowHasChanged = (id, boolean) =>
  ({
    type: types.SPECIMEN_ROW_HAS_CHANGED, id, boolean,
  });

export const resetRowHasChanged = (boolean) =>
  ({
    type: types.RESET_SPECIMEN_ROW_HAS_CHANGED, boolean,
  });

export const specimenSelect = specimen => ({ type: types.SPECIMEN_SELECT, specimen });

export const addSpecimen = (specimen) => ({ type: types.ADD_SPECIMEN, specimen });

/*
export const updateTopLevelSpecimenData = (caseId) => async dispatch => {
  try {
    const res = await axios.get(`${API_URL_PATHS.apiUrl}/specimens/${caseId}`, getTokenHeader());
    dispatch({type: types.UPDATE_SPECIMEN_TABLE, payload: {specimens: res.data.sort(compare)}});
  } catch (err) {
    console.log(err);
  }
};
*/

export const persistAnalysisThroughPortalTransition = (analysis, pathologist, specimenId) => {
  return {
    type: types.UPDATE_ANALYSIS_WHEN_OPENING_OR_CLOSING_PORTAL,
    payload: { analysis, pathologist: pathologist.email, specimenId },
  };
};


export const saveAnalysisClientOnly = (analysis, pathologist, specimenId, isValidation, isSubmitted) => {
  if (analysis) {
    analysis.hasChanged = true;
  }
  return {
    type: types.UPDATE_ANALYSIS,
    payload: {
      analysis,
      pathologist: pathologist._id,
      specimenId,
      hasUnsavedChanges: true,
      isValidation,
      validationComplete: isSubmitted,
    },
  };
};


export const getValidationSpecimens = (userId) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${API_URL_PATHS.apiUrl}/validationStudy/specimens/`,
      getTokenHeader(),
    );

    const data = res.data.map((specimen) => {
      if (!specimen.analyses[0]) {
        specimen.analyses[0] = {
          status: 'Not Started',
          assignee: userId,
          analysis: {
            partTwoSpecimenLevelForm: {},
          },
        };
      }
      return specimen;
    });
    dispatch({ type: types.GET_VALIDATION_SPECIMENS, payload: data });
  } catch (e) {
    console.log(e);
  }
};


export const goToHome = () => ({ type: types.GO_TO_HOME });

export const goToNextSpecimen = () => ({ type: types.GO_TO_NEXT });

export const saveAnalysis = (analysis, user, specimenId, isDone, isValidation, isReopen, formId) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  async dispatch => {
    const isValid = validateAnalysisValues(analysis);
    const body = {
      analysis: { partTwoSpecimenLevelForm: analysis },
      assignee: user._id,
      specimenId,
      isDone,
      isValid,
    };
    try {
      const res = await axios.post(`${API_URL_PATHS.apiUrl}/specimenAnalysis`, body, getTokenHeader());
      let newAnalysis = res.data;
      if (newAnalysis === undefined) {
        newAnalysis = {
          analysis: {
            partTwoSpecimenLevelForm: {},
            isValid,
          },
        };
      }
      dispatch({
        type: types.UPDATE_ANALYSIS,
        payload: {
          analysis: newAnalysis.analysis.partTwoSpecimenLevelForm,
          pathologist: user._id,
          specimenId,
          hasUnsavedChanges: false,
          validationComplete: isDone,
          analysisUpdatedAt: newAnalysis.analysisUpdatedAt,
          isValidation,
          isValid: newAnalysis.isValid,
        },
      });
      const message = (isReopen) ? 'Analysis reopened' : 'Analysis saved';
      const notification = getSuccessNotification(message);
      dispatch(displayNotification(notification));
      dispatch(removeStoredUnsavedAnalysis(formId));
      dispatch(checkAllFormsValidity());
      return true;
    } catch (e) {
      dispatch(displayNotification(getServerErrorNotification(e)));
      console.log(e);
      return false;
    }
  };


export const saveSpecimen = (caseId, specimen, type) => async dispatch => {
  const body = {
    caseId,
    specimen,
  };
  try {
    const { headers } = getTokenHeader();
    // previous method of calling axios did not work on delete. ie:  await axios[type](`${API_URL_PATHS.apiUrl}/specimen`, body, getTokenHeader());
    await axios({
      url: `${API_URL_PATHS.apiUrl}/specimen`,
      method: type,
      data: body,
      headers,
    });
    try {
      const res = await axios.get(`${API_URL_PATHS.apiUrl}/specimens/${caseId}`, getTokenHeader());
      dispatch({ type: types.UPDATE_SPECIMEN_TABLE, payload: { specimens: res.data, caseId } });
    } catch (err) {
      console.log('Error updating table: ', err);
    }
  } catch (err) {
    dispatch(displayNotification(getServerErrorNotification(err)));
    console.log('Error posting new specimen', err);
  }
};

export const updateCadessImageOfSelectedSpecimen = (newUrl, specimen) => dispatch => {
  axios.put(`${API_URL_PATHS.apiUrl}/specimens/cadessImage`, { specimen }, getTokenHeader())
    .then(response => {
      dispatch({
        type: types.UPDATE_CADESS_IMAGE,
        payload: { cadessImgUrl: response.data.cadessImgUrl },
      });
    }).catch(e => console.log(e));
};

export const setCadessOverlay = bool => ({ type: types.TOGGLE_CADESS_OVERLAY, payload: bool });

export const toggleCadessOverlay = () => ({ type: types.TOGGLE_CADESS_OVERLAY });

export const tempUpdateSpecimen = (specimen) => ({
  type: types.UPDATE_SPECIMEN_TEMP, payload: { specimen },
});

export const updateSpecimenField = (id, key, value) => ({
  type: types.UPDATE_SPECIMEN_FIELD, id, key, value,
});

export const uploadSpecimenImage = (position, data) =>
  ({ type: types.UPLOAD_SPECIMEN_IMAGE, data, position });

export const deleteSpecimenImage = (position, specimenId) => async dispatch => {
  try {
    await axios.post(`${API_URL_PATHS.apiUrl}/deleteSpecimenImage`, { specimenId }, getTokenHeader());
    dispatch({ type: types.DELETE_SPECIMEN_IMAGE, position });
  } catch (e) {
    console.log(e);
  }
};

export const plotSpecimenLocation = (id, coords) => ({
  type: types.PLOT_SPECIMEN_LOCATION, id, coords,
});
